module.exports = __webpack_public_path__ + "static/media/medal.1c7a42ac.svg";